import { useEffect, useState } from "react";
import api from "./api";
import { BLOG_INFO } from "../context/LangContext";

let cache = null;
let pending = null;

export const clearVisibleBlogs = () => { cache = null; pending = null; };

export function useVisibleBlogs() {
  const [ids, setIds] = useState(cache);
  useEffect(() => {
    if (cache) { setIds(cache); return; }
    pending = pending || api.get("/public/blogs").then((r) => { cache = r.data.map((b) => b.id); return cache; });
    pending.then(setIds).catch(() => { pending = null; setIds(Object.keys(BLOG_INFO)); });
  }, []);
  return ids;
}

export const BLOG_COUNT_WORDS = { 0: ["Blogs", "Blogs"], 1: ["Um blog", "One blog"], 2: ["Dois blogs", "Two blogs"], 3: ["Três blogs", "Three blogs"] };
